import { gql } from "../../../__generated__/gql";

export const LOGIN_MUTATION = gql(`
mutation signin($email: String!, $password: String!) {
  signin(email: $email, password: $password) {
    token
  }
}
`);
